//Main Logic
document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('ConfiguratorForm');

  // Helper to toggle visibility and ENABLE/DISABLE states
  const toggleVisibility = (elements, show, shouldClear = true) => {
    elements.forEach(item => {
      if (show) {
        item.style.display = 'block';
        // Enable inputs so they ARE sent
        item.querySelectorAll('input, select, textarea').forEach(el => el.disabled = false);
      } else {
        item.style.display = 'none';
        // Disable inputs so they ARE NOT sent
        item.querySelectorAll('input, select, textarea').forEach(el => {
          el.disabled = true;
          if (shouldClear) {
            if (el.type === 'checkbox' || el.type === 'radio') el.checked = false;
            else if (el.tagName === 'SELECT') el.selectedIndex = 0;
            else el.value = '';
          }
        });
      }
    });
  };

  // Initialize: Disable all downstream branches on page load
  toggleVisibility(document.querySelectorAll('.form-step-branch, .final-form-layer'), false, false);

  document.addEventListener('change', function(event) {
    const el = event.target;

    // STEP 1 -> STEP 2 LOGIC
    if (el.classList.contains('main-configurator-trigger')) {
      const mainVal = el.value;
      
      // Hide and Disable EVERYTHING downstream first
      toggleVisibility(document.querySelectorAll('.form-step-branch, .final-form-layer'), false);

      // Show and Enable ONLY the matched branch
      const branches = document.querySelectorAll('.form-step-branch');
      branches.forEach(branch => {
        if (branch.getAttribute('data-branch-id') === mainVal) {
          toggleVisibility([branch], true);
        }
      });
    }

    // STEP 3 -> STEP 4 LOGIC
if (el.classList.contains('main-step3-trigger')) {
  const subVal = el.value;
  
  // 1. Find the container for THIS specific dropdown
  const wrapper = el.closest('.step3-trigger-wrapper');
  
  // 2. Find the portal directly inside this wrapper
  const portal = wrapper.querySelector('.step4-portal');

  if (portal) {
    // 3. Find all layers inside this portal
    const layers = portal.querySelectorAll('.final-form-layer');

    layers.forEach(layer => {
      // 4. Ensure we only toggle layers that belong to THIS specific portal
      // (This prevents it from messing with the 5th or 6th layer accidentally)
      if (layer.closest('.step4-portal') === portal) {
        if (layer.getAttribute('data-step4-match') === subVal) {
          toggleVisibility([layer], true);
        } else {
          toggleVisibility([layer], false);
        }
      }
    });
  }
}
  });
});

function toggleCustomInput(selectElement) {
  const customDiv = selectElement.parentElement.querySelector('.custom-value-input');
  if (customDiv) {
    const input = customDiv.querySelector('input');
    if (selectElement.value.toLowerCase() === 'custom') {
      customDiv.style.display = 'block';
      if(input) {
        input.disabled = false;
        input.focus();
      }
    } else {
      customDiv.style.display = 'none';
      if(input) {
        input.disabled = true;
        input.value = '';
      }
    }
  }
}
//dropdown
function selectOption(li, value) {
    const wrapper = li.closest('.searchable-select-wrapper');
    const visibleInput = wrapper.querySelector('.searchable-input');
    const hiddenInput = wrapper.querySelector('input[type="hidden"]');
    
    visibleInput.value = value;
    hiddenInput.value = value;
    li.parentElement.classList.remove('active');
  }

  function filterOptions(input) {
    const wrapper = input.closest('.searchable-select-wrapper');
    const list = wrapper.querySelector('.custom-dropdown-list');
    const filter = input.value.toLowerCase();
    const items = list.querySelectorAll('li');
    const hiddenInput = wrapper.querySelector('input[type="hidden"]');
    
    // As user types, update the hidden input (for custom values)
    hiddenInput.value = input.value;

    items.forEach(item => {
      const text = item.textContent.toLowerCase();
      item.style.display = text.includes(filter) ? 'block' : 'none';
    });
  }